exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".menu_sidebar{background-color:#32a6cc!important}", ""]);

// exports
